import React from 'react';
import Const from 'constants';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';

class LineupPlayersSketch extends BaseLineupPlayers {
    constructor(props) {
        super(props);
        const {stacking} = props;
        this.stacking = stacking;
    }

    isPlayerInGroupTeams(player, groupTeamsNumber) {
        const {lineupId, rawLineups} = this.props;
        const simplexLineup = rawLineups.getLineup(lineupId);

        if (!simplexLineup) {
            return false;
        }

        const groupTeams = simplexLineup.getSplitted(Const.LP_TEAM_GROUP_PREFIX);
        for (let groupTeam of groupTeams) {
            const [teamName, groupNumber] = groupTeam;

            if (groupTeamsNumber !== Number(groupNumber)) {
                continue;
            } else if (player.team !== teamName) {
                continue;
            }

            if (!this.stacking.isDisallowedPositionsUsed()) {
                return true;
            }

            const disallowedPositions = this.stacking.getDisallowedPositionsByGroupNumber(groupTeamsNumber);
            return !inArray(player.positionName, disallowedPositions);
        }

        return false;
    }

    getStackClassNameByPlayer(player) {
        let className = '';
        if (this.isPlayerInGroupTeams(player, 1)) {
            className = 'primary-stack-color';
        } else if (this.isPlayerInGroupTeams(player, 2)) {
            className = 'secondary-stack-color';
        }
        return className;
    }
}

export {LineupPlayersSketch};
